import { http } from "@/shared/api/http";

export interface LogoConcept {
  id: string;
  label: string;
  svg: string;
  style_tags: string[];
}

export interface WorkspaceLogo {
  workspace_id: string;
  selected_kind: "none" | "curated" | "upload";
  selected_concept_id: string | null;
  selected_concept: LogoConcept | null;
  uploaded_logo_url: string | null;
  uploaded_logo_filename: string | null;
  concepts: LogoConcept[];
}

export const fetchWorkspaceLogo = (workspaceId: string): Promise<WorkspaceLogo> =>
  http<WorkspaceLogo>(`/workspaces/${workspaceId}/brand-assets/logo`);

export const selectWorkspaceLogo = (
  workspaceId: string,
  conceptId: string,
): Promise<WorkspaceLogo> =>
  http<WorkspaceLogo>(`/workspaces/${workspaceId}/brand-assets/logo/select`, {
    method: "POST",
    body: { concept_id: conceptId },
  });

export const uploadWorkspaceLogo = (workspaceId: string, file: File): Promise<WorkspaceLogo> => {
  const body = new FormData();
  body.append("file", file);
  return http<WorkspaceLogo>(`/workspaces/${workspaceId}/brand-assets/logo/upload`, {
    method: "POST",
    body,
  });
};

export const removeWorkspaceLogo = (workspaceId: string): Promise<WorkspaceLogo> =>
  http<WorkspaceLogo>(`/workspaces/${workspaceId}/brand-assets/logo`, {
    method: "DELETE",
  });
